<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 19:59:18
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-01 19:32:28
 * @Description: 鲸鱼资讯
 -->

<template>
  <div class="news-wrapper">
    <div class="main">
      <h2>鲸鱼资讯</h2>
      <div class="news-box">
        <template v-for="(item, index) in newsList">
          <router-link
            class="news-item"
            :key="index"
            v-if="index < 2"
            :to="`/about-us/news/content/${item.trendid}`"
          >
            <div class="img-box">
              <img :src="item.photo1" alt="" srcset="" />
            </div>
            <div class="text-box">
              <h4 class="title">{{ item.title }}</h4>
              <p class="date">{{ item.u_time }}</p>
              <p class="content" v-line-clamp:24="3">
                {{ item.summary }}
              </p>
            </div>
          </router-link>
        </template>

        <!-- <div class="news-item">
          <div class="img-box"></div>
          <div class="text-box">
            <h4 class="title">鲸鱼联合宜宾商业银行存管上线</h4>
            <p class="date">2019-03-10</p>
            <p class="content" v-line-clamp:24="3">
              近日，鲸鱼联合宜宾商业银行存管上线鲸鱼联合宜宾商业银行存管上线鲸鱼联合宜宾商业银行存鲸鱼联合宜宾商业银行存管上线管上线鲸银行宜宾商业银行存线商业银行存线商业银行存线商业银行存线
            </p>
          </div>
        </div> -->
      </div>
      <div class="main-footer">
        <router-link class="more-news" to="/about-us/announcement">更多公告 > </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'news',
  data() {
    return {
      newsList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      this.loading = true;
      try {
        const res = await this.$http.post('cg/commonRequest', {
          method: 'pinfo.trend.list',
          token: ''
        });
        if (res.code === 200) {
          this.newsList = res.data.list.splice(0, 2);
          // this.newsList = res.data.list;
          this.newsList.forEach(x => {
            x.u_time = x.u_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.news-wrapper {
  height: 446px;
  background: url('https://files.jinr.com/jinr-index/img/index-mid-bg.png') no-repeat;
  background-position: 50%;
  overflow: hidden;
  .main {
    width: 1200px;
    margin: 0 auto;
    h2 {
      font-family: 'PingFangSC-Medium';
      font-size: 22px;
      color: #333333;
      text-align: center;
      margin: 60px 0;
    }
    .news-box {
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .news-item {
        display: flex;
        width: 586px;
        height: 208px;
        transition: 0.4s linear;
        box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.11);
        cursor: pointer;
        &:hover {
          box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.4);
        }
        .img-box {
          width: 238px;
          height: 208px;
          background: #fcfcfc;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text-box {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          background: #fff;
          padding: 26px 30px;
          box-sizing: border-box;
          .title {
            position: relative;
            // margin: 0 0 27px 0;
            font-family: 'PingFangSC-Medium';
            font-size: 16px;
            color: #333333;
            &::before {
              content: '';
              position: absolute;
              width: 4px;
              height: 100%;
              background: #2c6eff;
              left: -14px;
              top: 0;
            }
          }
          .content {
            width: 294px;
            height: 72px;
            font-family: 'PingFangSC-Regular';
            font-size: 12px;
            color: #696969;
            line-height: 24px;
          }
        }
      }
    }
    .main-footer {
      text-align: center;
    }
    .more-news {
      display: inline-block;
      font-size: 16px;
      color: #666666;
      text-align: center;
      margin: 38px auto;
      line-height: 16px;
    }
  }
}
</style>
